import { useMemo } from 'react';

import { CollapseColumnHeader } from '../components/collapseColumnHeader';
import { HierarchyVersionColumnCell } from '../components/HierarchyVersionColumnCell';

export const useTableTreeVersionColumns = (props: {
    shownIds: number[];
    hideItems: (itemsIds: number[]) => any;
    showItems: (itemsIds: number[]) => any;
    switchExpandAll: (expandAll: boolean) => any;
    rows: any;
    tableTreeItems: any;
}) => {
    const { shownIds, showItems, hideItems, switchExpandAll, rows, tableTreeItems } = props;

    return useMemo(
        () => [
            {
                title: (
                    <CollapseColumnHeader
                        switchExpandAll={switchExpandAll}
                        rows={rows}
                        tableTreeItems={tableTreeItems}
                        shownIds={shownIds}
                    />
                ),
                accessor: 'name',
                renderCell: (treeItem: any) => (
                    <HierarchyVersionColumnCell
                        item={treeItem}
                        shownIds={shownIds}
                        hideItems={hideItems}
                        showItems={showItems}
                    />
                ),
            },
        ],
        [hideItems, rows, showItems, shownIds, switchExpandAll, tableTreeItems],
    );
};
